var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.0746L26 10.9751V18.4876V26H21L16 26V23.5124V21.0249L18.4808 21.005L20.9519 20.9751L20.9808 16.0298L21 11.0746L20.7885 11.0249C24.75 10.9751 18.4231 10.9851 15.8077 10.995L11.0481 11.0249L11.0192 18.5075L11 26H8.5H6V16V6H13.5H21V11.0746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcl);
export default __webpack_public_path__ + "static/media/PARCL.29904e1a3c879128c47e432bbaaa42e7.svg";
export { ForwardRef as ReactComponent };